<script setup>
import { ref, onMounted } from 'vue'
import ProductItem from './ProductItem.vue'

const year = ref(null)

defineProps({
  title: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  products: {
    type: Array,
    default: () => [],
  },
  category: {
    type: Object,
    default: () => {},
  },
})

onMounted(() => {
  let offset = 85
  const adminBar = document.getElementById('wpadminbar')
  if (adminBar) {
    offset += adminBar.clientHeight
  }

  if (year.value) {
    // eslint-disable-next-line no-undef
    new hcSticky(year.value, {
      top: offset,
      bottom: 0,
      responsive: {
        991: {
          disable: true,
        },
      },
    })
  }
})
</script>

<template>
  <div class="cat-section">
    <span v-if="category.year" ref="year" class="cat-section__year">{{
      category.year
    }}</span>
    <h2 class="cat-section__title">{{ title }}</h2>
    <!-- eslint-disable vue/no-v-html -->
    <div
      v-if="category.subtitle"
      class="cat-section__desc"
      v-html="category.subtitle"
    ></div>
    <!-- eslint-enable -->
    <div v-if="products.length" class="cat-section__products grid fix-gap-sm">
      <ProductItem
        v-for="product in products"
        :key="product.id"
        :product="product"
        class="g-col-12 g-col-sm-6 g-col-md-4 fix-gap-sm"
      />
    </div>
  </div>
</template>

<style lang="scss">
@import '../scss/category-section';
</style>
